import { useEffect, useRef } from 'react';
import { SignalRService } from '../services/signalr';

export function useRealtimeRefresh(refresh: () => void, enabled = true) {
  const latest = useRef(refresh);
  latest.current = refresh;
  useEffect(() => {
    if (!enabled) return;
    let timer: number | null = null;
    const stop = () => {
      if (timer !== null) window.clearInterval(timer);
      timer = null;
    };
    const start = () => {
      if (timer === null) timer = window.setInterval(() => latest.current(), 15000);
    };
    const onDebug = (event: Event) => {
      const kind = (event as CustomEvent).detail?.kind;
      if (kind === 'connected' || kind === 'reconnected') {
        stop();
        latest.current();
      } else if (['closed', 'reconnecting', 'connection-failed', 'auth-missing', 'negotiate-failed', 'negotiate-invalid'].includes(kind)) {
        start();
      }
    };
    if (SignalRService.getInstance().getConnectionState() !== 'Connected') start();
    window.addEventListener('nog:signalr:debug', onDebug);
    return () => { stop(); window.removeEventListener('nog:signalr:debug', onDebug); };
  }, [enabled]);
}